import { GENDER_MAP, LANGUAGE_CODE_MAP, LOCATION_ID_MAP, SELECTORS } from '$utils/constants';

const locationEl = document.querySelector(SELECTORS.location) as HTMLSelectElement;
const locationDDLabel = document.querySelector(SELECTORS.locationDD) as HTMLDivElement;
const languageEl = document.querySelector(SELECTORS.language) as HTMLSelectElement;
const languageDDLabel = document.querySelector(SELECTORS.languageDD) as HTMLDivElement;
const ageFromEl = document.querySelector(SELECTORS.ageFrom) as HTMLSelectElement;
const ageToEl = document.querySelector(SELECTORS.ageTo) as HTMLSelectElement;
const ageDDLabel = document.querySelector(SELECTORS.ageDD) as HTMLDivElement;
const genderEl = document.querySelector(SELECTORS.gender) as HTMLSelectElement;
const genderDDLabel = document.querySelector(SELECTORS.genderDD) as HTMLDivElement;

const locationAudienceEl = document.querySelector(SELECTORS.audienceLocation) as HTMLSelectElement;
const locationAudienceDDLabel = document.querySelector(
  SELECTORS.audienceLocationDD
) as HTMLDivElement;
const locationPercentageAudienceEl = document.querySelector(
  SELECTORS.audienceLocationPercentage
) as HTMLElement;
const locationAudiencePhrase = document.querySelector(
  SELECTORS.audienceLocationPercentagePhrase
) as HTMLDivElement;
const languageAudienceEl = document.querySelector(SELECTORS.audienceLanguage) as HTMLSelectElement;
const languageAudienceDDLabel = document.querySelector(
  SELECTORS.audienceLanguageDD
) as HTMLDivElement;
const languagePercentageAudienceEl = document.querySelector(
  SELECTORS.audienceLanguagePercentage
) as HTMLElement;
const languageAudiencePhrase = document.querySelector(
  SELECTORS.audienceLanguagePercentagePhrase
) as HTMLDivElement;
const ageFromAudienceEl = document.querySelector(SELECTORS.audienceAgeFrom) as HTMLSelectElement;
const ageToAudienceEl = document.querySelector(SELECTORS.audienceAgeTo) as HTMLSelectElement;
const ageFromAudienceDDLabel = document.querySelector(SELECTORS.audienceAgeDD) as HTMLDivElement;
const genderAudienceEl = document.querySelector(SELECTORS.audienceGender) as HTMLSelectElement;
const genderPercentageAudienceEl = document.querySelector(
  SELECTORS.audienceGenderPercentage
) as HTMLElement;
const genderAudienceDDLabel = document.querySelector(SELECTORS.audienceGenderDD) as HTMLDivElement;
const genderAudiencePhrase = document.querySelector(
  SELECTORS.audienceGenderPercentagePhrase
) as HTMLDivElement;

export const setUpDropDownListener = () => {
  //creator dropdowns
  //location
  locationEl.addEventListener('change', (e) => {
    //@ts-ignore
    locationDDLabel.innerText = LOCATION_ID_MAP[locationEl.value];
  });

  //Language
  languageEl.addEventListener('change', () => {
    //@ts-ignore
    languageDDLabel.innerText = LANGUAGE_CODE_MAP[languageEl.value];
  });
  //Gender
  genderEl.addEventListener('change', () => {
    //@ts-ignore
    genderDDLabel.innerText = GENDER_MAP[genderEl.value];
  });

  let ageFilterText = `Age`;
  //Age
  ageFromEl.addEventListener('change', () => {
    ageFilterText = `${ageFromEl.value} - ${ageToEl.value} `;
    //@ts-ignore
    ageDDLabel.innerText = ageFilterText;
  });

  ageToEl.addEventListener('change', () => {
    ageFilterText = `${ageFromEl.value} - ${ageToEl.value}`;
    ageDDLabel.innerText = ageFilterText;
  });

  //audience dropdowns
  handleChangeEvent(locationAudienceEl, () => {
    //@ts-ignore
    const locationName = LOCATION_ID_MAP[locationAudienceEl.value];
    // const originalText = `More than 10% audience's location is selected location`;
    // locationAudiencePhrase.innerText = originalText;
    locationAudienceDDLabel.innerText = locationName;
    locationAudiencePhrase.innerText = locationName;
  });

  handleChangeEvent(languageAudienceEl, () => {
    const originalText = `More than 10% audience's language is selected location`;
    //@ts-ignore
    const languageName = LANGUAGE_CODE_MAP[languageAudienceEl.value];
    languageAudienceDDLabel.innerText = languageName;
    languageAudiencePhrase.innerText = languageName;
  });

  handleChangeEvent(genderAudienceEl, () => {
    const originalText = `More than 10% audience's gender is selected location`;
    //@ts-ignore
    const genderName = GENDER_MAP[genderAudienceEl.value];
    genderAudienceDDLabel.innerText = genderName;
    genderAudiencePhrase.innerText = genderName;
  });

  handleChangeEvent(ageFromAudienceEl, () => {
    //@ts-ignore
    ageFromAudienceDDLabel.innerText = `${ageFromAudienceEl.value}-` + `${ageToAudienceEl.value}`;
  });
  handleChangeEvent(ageToAudienceEl, () => {
    //@ts-ignore
    ageFromAudienceDDLabel.innerText = `${ageFromAudienceEl.value}-` + `${ageToAudienceEl.value}`;
  });

  //remove eventlistener
};

const handleEvent = (
  element: HTMLElement,
  event: string,
  callback: EventListenerOrEventListenerObject
) => {
  if (!event || !callback || !element) return;
  element.addEventListener(event, callback);
};

const handleChangeEvent = (element: HTMLElement, callback: EventListenerOrEventListenerObject) =>
  handleEvent(element, 'change', callback);
